// ExpertConnect.jsx
// ExpertConnect.jsx
import React, { useState } from 'react';
import {
  Users,
  ArrowRight,
  Star,
  Clock,
  Award,
  Briefcase,
  User,
  Mail,
  Phone,
  MapPin,
  CheckCircle,
  Sparkles,
  Shield,
  Zap,
  Search,
  Filter,
  TrendingUp,
  Crown,
  MessageCircle,
  Calendar,
  Lock,
  Eye,
  EyeOff,
  LogIn as LoginIcon,
  Building2,
  Factory
} from 'lucide-react';
import './ExpertConnect.css';
import Navbar from './Navbar';
import WhyConsultFirst from './WhyConsultFirst';
import Expertteam from './Expertteam';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

const ExpertConnect = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const experts = [
    {
      id: 1,
      name: "Ravi Kumar",
      role: "CAD & DFM Expert",
      experience: "15 yrs",
      rate: "₹500",
      rating: 4.9,
      reviews: 127,
      avatar: "RK",
      expertise: ["CAD Modeling", "DFM Analysis", "3D Printing"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Product Design Engineer",
      experience: "10 yrs",
      rate: "₹650",
      rating: 4.8,
      reviews: 98,
      avatar: "PS",
      expertise: ["Product Design", "Prototyping", "3D Modeling"],
      availability: "Busy",
      verified: true,
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "Manufacturing Specialist",
      experience: "12 yrs",
      rate: "₹750",
      rating: 4.7,
      reviews: 85,
      avatar: "AP",
      expertise: ["Manufacturing", "Process Optimization", "Quality Control"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    }
  ];

  const stats = [
    { value: "500+", label: "Experts" },
    { value: "4.8", label: "Avg Rating" },
    { value: "95%", label: "Success Rate" },
    { value: "50+", label: "Expertise Areas" }
  ];

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginError('');
    setIsLoading(true);

    // Simulate login
    setTimeout(() => {
      setIsLoading(false);
      if (email === 'expert@apic.in' && password === 'password') {
        // Navigate to expert dashboard or marketplace
        navigate('/expert-marketplace');
      } else {
        setLoginError('Invalid email or password. Please try again.');
      }
    }, 1500);
  };

  return (
    <>
      <Navbar />
      <section className="expert-connect">
        {/* Background Image */}
        <div className="expert-bg-container">
          <img
           src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&q=80"
            alt="Expert network background"
            className="expert-bg-image"
          />
          <div className="expert-bg-overlay"></div>
          <div className="expert-bg-glow-1"></div>
          <div className="expert-bg-glow-2"></div>
        </div>

        <div className="expert-container">
          {/* ========== HERO SECTION ========== */}
          <div className="expert-hero">
            {/* Left Side - Text Content */}
            <div className="expert-hero-left">
              <div className="expert-badge">
                <Sparkles size={16} className="expert-badge-icon" />
                <span>Expert Network</span>
              </div>

              <h1 className="expert-hero-title">
                <span className="expert-hero-title-line1">The right expertise can turn</span>
                <span className="expert-hero-title-line2">a good idea into a great product.</span>
              </h1>

              <p className="expert-hero-description">
                Every successful prototype starts with the right technical decisions. 
                APIC ProtoHub connects innovators with engineers, product designers, 
                manufacturing specialists and technology experts who help transform 
                ideas into technically feasible, manufacturable, cost-effective products.
              </p>

              {/* CTA Buttons */}
              <div className="expert-hero-cta">
                <button className="expert-cta-primary">
                  <Search size={18} />
                  <span>Find an Expert</span>
                  <ArrowRight size={18} className="expert-cta-arrow" />
                </button>
                <button className="expert-cta-secondary">
                  <User size={18} />
                  <span>Become an Expert</span>
                </button>
              </div>

              {/* Stats */}
              <div className="expert-stats">
                {stats.map((stat, index) => (
                  <React.Fragment key={index}>
                    <div className="expert-stat-item">
                      <p className="expert-stat-value">{stat.value}</p>
                      <p className="expert-stat-label">{stat.label}</p>
                    </div>
                    {index < stats.length - 1 && (
                      <div className="expert-stat-divider"></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Right Side - Login Form */}
            <div className="expert-hero-right">
              <div className="expert-login-card">
                <div className="expert-login-header">
                  
                  <h2 className="expert-login-title">Welcome Back</h2>
                  <p className="expert-login-subtitle">Sign in to access expert network</p>
                </div>

                <form className="expert-login-form" onSubmit={handleLogin}>
                  <div className="expert-login-group">
                    <label className="expert-login-label">
                      <Mail size={16} />
                      Email Address
                    </label>
                    <div className="expert-login-input-wrapper">
                      <Mail size={18} className="expert-login-input-icon" />
                      <input
                        type="email"
                        className="expert-login-input"
                        placeholder="expert@apic.in"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="expert-login-group">
                    <label className="expert-login-label">
                      <Lock size={16} />
                      Password
                    </label>
                    <div className="expert-login-input-wrapper">
                      <Lock size={18} className="expert-login-input-icon" />
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="expert-login-input"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="expert-login-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                  </div>

                  {loginError && (
                    <div className="expert-login-error">
                      <AlertCircle size={16} />
                      <span>{loginError}</span>
                    </div>
                  )}

                  <div className="expert-login-options">
                    <label className="expert-login-checkbox">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <span>Remember me</span>
                    </label>
                    <a href="#" className="expert-login-forgot">Forgot password?</a>
                  </div>

                  <button
                    type="submit"
                    className="expert-login-submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="expert-login-spinner"></span>
                        Signing in...
                      </>
                    ) : (
                      <>
                        <LoginIcon size={18} />
                        Sign In
                      </>
                    )}
                  </button>

                </form>
              </div>
            </div>
          </div>

          {/* ========== EXPERTS SECTION ========== */}
          
        </div>
      </section>
      <Expertteam />
      <WhyConsultFirst />
      <Footer />
    </>
  );
};

// AlertCircle icon component
const AlertCircle = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

export default ExpertConnect;